import * as React from "react";
import {Body, Section} from "@athena-portal/components";
import {lazyInject} from "@athena-portal/core";
import {
    CommonHelpers,
    ICustomerPortalService,
    INotification,
    INotificationService,
    SessionStorageItemEnum,
    Types
} from "@falcon/services";
import {Redirect} from "react-router";
import {VersionDisplay} from "./VersionDisplay";
import {getSessionStorage, setSessionStorage} from "./CommonFunctions";
import {PartyPropertyEnum} from "@falcon/services/dist/helpers/enums";
import {PartyProperty} from "@falcon/services/dist/model/PartyProperty";
interface IState {
    doRedirect: boolean,
    doRedirectToEventWarningPage: boolean,
    doRedirectToAllianzPromotionPage: boolean,
    notificationMessage: string,
}

export class Layout extends React.Component<{}, IState> {
    @lazyInject(Types.NotificationService)
    private notificationService: INotificationService;

    @lazyInject(Types.CustomerPortalService)
    private customerPortalService: ICustomerPortalService;

    constructor(props: {}) {
        super(props);
        this.state = {
            doRedirect: false,
            doRedirectToEventWarningPage: false,
            doRedirectToAllianzPromotionPage: false,
            notificationMessage: "",
        };
    }

    public componentDidMount() {
        this.removeAggregatorLoadingScreen();

        this.notificationService.getFeed().subscribe((note: INotification) => {
            if (note && this.state.notificationMessage.indexOf(note.message) === -1) {
                this.setState({
                    doRedirect: true,
                    notificationMessage: `${this.state.notificationMessage}\n${note.message}`
                })
            }
        });

        if (window.location.pathname.includes("/dashboard")) {
            this.setRedirectToEventWarningPage();
            this.setRedirectToAllianzPromotionPage();
        }
    }

    public render() {
        return (
            <React.Fragment>
                {(this.doRedirectToEventWarningPage()) && (<Redirect to={`/EventWarningPage`}/>)}
                {(this.doRedirectToAllianzPromotionPage()) && (<Redirect to={`/allianzPromotion`}/>)}
                <div>
                    <div>
                        <div className="container-fluid">
                            <div className="container pt-3 pb-3">
                                <Body/>
                            </div>
                        </div>
                    </div>
                </div>
                <footer className="footer-position">
                    <Section id="footer"/>
                </footer>
                <VersionDisplay/>
                {this.doRedirect() && (<Redirect to={`/error?e=${this.state.notificationMessage}`}/>)}
            </React.Fragment>
        );
    }

    private removeAggregatorLoadingScreen = () => {
        const loadingScreenContainer = document.getElementById("loading-screen-container");
        if (loadingScreenContainer) {
            loadingScreenContainer.classList.add("d-none");
        }
    }

    private doRedirect = (): boolean => {
        if (this.state.doRedirect) {
            this.setState({doRedirect: false});
            return true;
        }


        return false;
    }

    private doRedirectToEventWarningPage = (): boolean => {
        if (this.state.doRedirectToEventWarningPage) {
            this.setState({doRedirectToEventWarningPage: false});
            return true;
        }

        return false;
    }

    private doRedirectToAllianzPromotionPage = (): boolean => {
        if (this.state.doRedirectToAllianzPromotionPage) {
            this.setState({doRedirectToAllianzPromotionPage: false});
            return true;
        }

        return false;
    }

    private async setRedirectToEventWarningPage() {
        const isEventWarningPageShown = CommonHelpers.getSessionStorage(SessionStorageItemEnum.SESSION_STORAGE_EVENT_WARNING_PAGE_SHOWN);
        if (isEventWarningPageShown) {
            return;
        }
    }

    private async setRedirectToAllianzPromotionPage() {
        const isAllianzPromotionShown = getSessionStorage(SessionStorageItemEnum.SESSION_STORAGE_ALLIANZ_PROMOTION_SHOWN);
        if (isAllianzPromotionShown) {
            return;
        }

        const showAllianzPromotionToCustomer = await this.isAllianzPromotion();
        if (!showAllianzPromotionToCustomer) {
            return;
        }

        const latestPolicies = await this.customerPortalService.getUserPoliciesWithLatestVersions().toPromise();
        if (!latestPolicies?.length) {
            return;
        }

        this.setState({ doRedirectToAllianzPromotionPage: true });
        // Remember that we will show promotion now, so it is not shown again in the same session
        setSessionStorage(SessionStorageItemEnum.SESSION_STORAGE_ALLIANZ_PROMOTION_SHOWN, true);

        const partyProperty = await this.fetchPartyPropertyByPropertyKey(PartyPropertyEnum.ALLIANZ_PROMOTION_SHOWN);
        const count = partyProperty?.value ? Number(partyProperty.value) : 0;
        this.customerPortalService.updatePartyProperty(PartyPropertyEnum.ALLIANZ_PROMOTION_SHOWN, (count + 1).toString())
            .subscribe(() => {
                // No-op
            })
    }
    private async fetchPartyPropertyByPropertyKey(key: PartyPropertyEnum): Promise<PartyProperty> {
        const observable = this.customerPortalService.getPartyPropertyByPropertyKey(key);
        return await observable.toPromise();
    }
    private async isAllianzPromotion(): Promise<boolean> {
        const observable = this.customerPortalService.isAllianzPromotion();
        return await observable.toPromise();
    }
}



// WEBPACK FOOTER //
// ./src/Layout.tsx